export function mix<T>(props: T, update: Partial<T>): T {
	return {
		...props,
		...update,
	};
}
